export const getPurchasePresentTypeFilter = state => state.purchasePresentType.filter
